import React from "react";
import { SearchIcon } from "../../../assets/icons/index";

interface IEmptyResultsProps {
  title?: string;
  subtitle?: string;
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const EmptyResults: React.FC<IEmptyResultsProps> = ({
  title = "No matching results",
  subtitle = "Adjust your filters and try again.",
  Icon = SearchIcon,
}) => (
  <div className="flex flex-col items-center justify-center py-20 text-gray-400 select-none">
    <Icon className="w-24 h-24 mb-4 opacity-40" />
    <p className="text-lg font-medium text-gray-500">{title}</p>
    <p className="text-sm mt-1">{subtitle}</p>
  </div>
);
